const getLastWeekMonday = (dateStr: string) => {
  // Parse the input date string
  const date = new Date(dateStr);

  // Get the day of the week (0 for Sunday, 1 for Monday, ..., 6 for Saturday)
  const dayOfWeek = date.getUTCDay();

  // Calculate the number of days to subtract to get to the previous Monday
  // If it's already Monday, we need to go back 7 days to get the previous Monday
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1 + 7;

  // Create a new Date object for the previous Monday
  const previousMonday = new Date(date);
  previousMonday.setUTCDate(date.getUTCDate() - daysToSubtract);

  // Format the date as "YYYY-MM-DD HH:mm:ss"
  const year = previousMonday.getUTCFullYear();
  const month = String(previousMonday.getUTCMonth() + 1).padStart(2, "0");
  const day = String(previousMonday.getUTCDate()).padStart(2, "0");
  const hours = String(previousMonday.getUTCHours()).padStart(2, "0");
  const minutes = String(previousMonday.getUTCMinutes()).padStart(2, "0");
  const seconds = String(previousMonday.getUTCSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export default getLastWeekMonday;
